module.exports = __webpack_public_path__ + "static/media/otp-image.c8af3f05.png";